import getConfig from 'next/config';

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

export const IS_DEVELOPMENT = process.env.NODE_ENV !== 'production';
export const PUBLIC_RUNTIME_CONFIG = publicRuntimeConfig || {};
export const SERVER_RUNTIME_CONFIG = serverRuntimeConfig || {};
export const GA_TRACKING_ID = 'G-XG1WCNCVLB';
export const ADSENSE_ID = '8990558636310587';

/** Cache Stuff */
export const CACHE_TAGS_HEADER_NAME = 'Cache-Tags';
export const DRUPAL_CACHE_TAGS_HEADER_NAME = 'x-drupal-cache-tags';
export const GLOBAL_CACHE_TAG = 'trabland';
export const VARNISH_CACHE_TIME = 604800; // 1 week
export const BROWSER_CACHE_TIME = 60; // 1 minute
export const STALE_WHILE_REVALIDATE = 302400; // 0.5 week

export const API_HASH_KEY = '39o48iujidgjosdf012983!@#809gew3g9';
export const API_HASH_PREFIX = 'trabland';
export const API_HASH_SUFFIX = 'tvv';
